import React from "react";
import ReactDOM from "react-dom/client";
import AuthGate from "./Auth";
import IntercoIQ from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AuthGate appName="IntercoIQ">{(auth) => <IntercoIQ auth={auth} />}</AuthGate>);
